import { Longform } from "@anthra/ui/typography"
import { createFileRoute } from "@tanstack/react-router"

import { Points, ProsePage, Section } from "@/components/prose-page"

/**
 * Help.
 *
 * Answers the questions the product's own screens raise and cannot answer in
 * place: why the code has not arrived, what the statuses mean, what happens to
 * an uploaded document. Everything here is drawn from how the app actually
 * behaves rather than from a generic FAQ.
 */
export const Route = createFileRoute("/help")({ component: Help })

function Help() {
	return (
		<ProsePage
			title="Help"
			updated="2026-08-25"
			intro="If none of this covers it, write to help@swamithra.com and a person will read it."
		>
			<Section title="The OTP was not received">
				<Longform>
					OTP is sent on the WhatsApp number provided by you. It is valid for 10 minutes.
				</Longform>
				<Points
					items={[
						"Check the number.",
						"Make sure WhatsApp is installed and registered on that number.",
						"Wait a minute before asking for another one. Asking again too quickly does not send a second OTP.",
						"Look in WhatsApp itself rather than your SMS inbox. We never send OTPs by SMS or email.",
					]}
				/>
				{/* <Longform>
					Nobody from Swamithra will ever ask you to read an OTP out. If someone does,
					they are not from Swamithra.
				</Longform> */}
			</Section>

			<Section title="What the Tabs mean">
				<Points
					items={[
						"Open. We have your question and an expert has not started on it yet.",
						"In Progress. An expert is working on it.",
						"Answered. There is a reply in the thread. You can ask a follow-up in the same thread.",
						"Closed — the matter is finished. A closed question cannot be reopened, so start a new one if something else comes up.",
					]}
				/>
			</Section>

			<Section title="Asking a question">
				<Longform>
					Submit your queries relating to Income tax – a tax expert replies privately and
					securely. You can attach up to three files, 5 MB each, as PDF, JPG or PNG.
				</Longform>
				<Points
					items={[
						"A question cannot be edited once it is sent. Add anything you have missed as a follow-up in the thread.",
						"Everything about one Question stays in one thread: scans, drafts, follow-ups and the expert's reply.",
					]}
				/>
			</Section>

			<Section title="Getting a draft vetted">
				<Longform>
					If you have already written a reply, send it with the notice and an expert
					checks it before you file.Vetting has two upload sections, the Draft to be
					vetted and the Relevant Documents. You can attach up to three files, 5 MB each,
					as PDF, JPG or PNG.
				</Longform>
			</Section>

			<Section title="Your documents">
				<Points
					items={[
						"Only you and the expert panel can open what you upload.",
						"Document links are short-lived and are generated fresh each time you open one, so a copied link stops working.",
					]}
				/>
			</Section>

			<Section title="Signing in and out">
				<Longform>
					There is no password. You sign in with your WhatsApp number and a fresh OTP each
					time. A session stays open for 24 hours of inactivity, then asks for a new OTP.
				</Longform>
			</Section>

			<Section title="Still stuck">
				<Longform>
					Write to help@swamithra.com with your question reference Number.
				</Longform>
			</Section>
		</ProsePage>
	)
}
